<template>
  <section class="page-panel grid-stack grid-gap-20">
    <h2>Pristup nije dozvoljen</h2>
    <p>Nemate potrebne ovlasti za pristup ovoj stranici.</p>
  </section>
</template>

<script setup>
defineOptions({
  name: 'Forbidden',
})
</script>
